import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const clearLegacyOfflineState = async () => {
  if (typeof window === "undefined") return;

  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ("caches" in window) {
    const cacheKeys = await window.caches.keys();
    await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
  }
};

void clearLegacyOfflineState().catch((error) => {
  console.error("Failed to clear legacy offline state", error);
});

createRoot(document.getElementById("root")!).render(<App />);
